import React from "react"
// import { graphql } from 'gatsby'
// import Img from 'gatsby-image'
import Layout from "../components/layout"
import Seo from "../components/seo"

const About = ({ location }) => (
  <Layout>
    <Seo
      pagetitle="KameWalkについて"
      pagepath={location.pathname}
      // pageimg={data.about.childImageSharp.original.src}
      // pageimgw={data.about.childImageSharp.original.width}
      // pageimgh={data.about.childImageSharp.original.height}
    />
    <div className="content">
      <h2>tecchan</h2>
      <p style={{ marginBottom: "50px" }}>
        ピチピチの20代。趣味は散歩とか読書とか。大学に入ってからピアノを始めた。ちょっとずつ弾けるようになってきて超楽しいです。
        <br />
        最近、基本情報技術者試験に受かりました。イエイ。
      </p>
      <h2>このブログについて</h2>
      <p>
        ブログやポートフォリオサイトを作っておくと良いよ的な話を聞いたので作ってみました。
        <br />
        僕が生活の中で新しく知ったことやプログラミングのことについて書けたらいいなぁと思っています。
        <br />
        少しずつサイトのデザインもよくしていきたいです。
      </p>
    </div>
  </Layout>
)
export default About
// export const query = graphql`
//   query {
//     about: file(relativePath: { eq: 'about.jpg' }) {
//       childImageSharp {
//         fluid(maxWidth: 1600) {
//           ...GatsbyImageSharpFluid_withWebp
//         }
//         original {
//           src
//           height
//           width
//         }
//       }
//     }
//   }
// `
